export default __webpack_public_path__ + "static/media/logocivil.5d8ba155.png";